export { default as PostItem } from './component';
